import React, { createContext, useContext, useState, useCallback } from 'react';

const PageHeaderContext = createContext(null);

export function PageHeaderProvider({ children }) {
  const [header, setHeaderState] = useState({ title: null, description: null });

  const setPageHeader = useCallback((value) => {
    setHeaderState(value == null ? { title: null, description: null } : { ...value });
  }, []);

  const value = {
    title: header.title,
    description: header.description,
    setPageHeader,
  };

  return (
    <PageHeaderContext.Provider value={value}>
      {children}
    </PageHeaderContext.Provider>
  );
}

export function usePageHeader() {
  const context = useContext(PageHeaderContext);
  if (!context) {
    return { title: null, description: null, setPageHeader: () => {} };
  }
  return context;
}
